/**
 *
 * Checkbox Field
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { Label, Input, FormGroup } from "reactstrap"

function EmployeeCheckboxField(props) {
  const {
    label,
    checked,
    id,
    name,
    value,
    onChange,
    isInvalid,
    labelStyle,
    required,
  } = props

  return (
    <React.Fragment>
      <FormGroup className="mb-3">
        <div className="form-check">
          <Label
            className="form-check-label"
            htmlFor={`${id}-${name}`}
            style={labelStyle}
          >
            {" "}
            {label} {required ? <span style={{ color: "red" }}>*</span> : null}
          </Label>
          <Input
            type="checkbox"
            className="form-check-input"
            id={`${id}-${name}`}
            name={name}
            onChange={onChange}
            isInvalid={isInvalid}
            // checked={value}
            value={value}
            checked={checked}
          />
        </div>
      </FormGroup>
    </React.Fragment>
  )
}

EmployeeCheckboxField.propTypes = {
  t: PropTypes.any,
  id: PropTypes.any,
  checked: PropTypes.any,
  label: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  labelStyle: PropTypes.object,
  isInvalid: PropTypes.any,
  required: PropTypes.bool,
}

export default EmployeeCheckboxField
